// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"page-primaryButton-2pyYVx","pageWrapper":"page-pageWrapper-1VDTLK","header":"page-header-2HSLy9","body":"page-body-1jtafl","content":"page-content-1DPyLw"};